import './js/layouts/libraryButtonSwitch';
import './js/genres/sortLibrary';
import './js/layouts/movieCardModal';
import './js/layouts/userAuthModal';
import './js/layouts/teamModal';
import './js/firebase/firebase';
import './js/components/scrollTo';
import './js/components/colorTheme';
